module.exports = __webpack_public_path__ + "static/media/BlankProfile.d20694f0.png";